interface EpisodeListProps {
  count: number;
  onDemo: (action: string) => void;
}

export default function EpisodeList({ count, onDemo }: EpisodeListProps) {
  const episodes = Array.from({ length: count }, (_, i) => i + 1);

  return (
    <div>
      <div className="md:hidden">
        <select
          onChange={(e) => {
            if (e.target.value) onDemo(`第 ${e.target.value} 集`);
            e.target.value = "";
          }}
          defaultValue=""
          className="w-full bg-background-200 border border-background-300 rounded-md px-3 py-3 text-sm text-foreground-950 outline-none cursor-pointer"
        >
          <option value="" disabled>
            选择剧集（演示）
          </option>
          {episodes.map((ep) => (
            <option key={ep} value={ep}>
              第 {ep} 集
            </option>
          ))}
        </select>
      </div>

      <div className="hidden md:grid grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-2">
        {episodes.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onDemo(`第 ${ep} 集`)}
            className="py-2.5 rounded-md bg-background-200 border border-background-300 text-sm text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
          >
            第 {ep} 集
          </button>
        ))}
      </div>
    </div>
  );
}